"use strict";
/**
 * @copyright Microsoft Corporation. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=signals.js.map